<div class="password-reset-container-outer">
    <div class="password-reset-container-inner">
        <!-- Form -->
        <ng-container *ngIf="!state.loading; else stateLoading">
            <ng-container *ngIf="!state.error; else stateError">
                <div class="card">
                    <div class="p-15">
                        <ng-container>
                            <h1 class="standard-heading">{{header}}</h1>
                            <div class="standard-description">{{subheader}}</div>
                        </ng-container>
                        <!-- <ng-container *ngSwitchCase="false">
                            <h1 class="standard-heading" translate>{{eAuthMessages.CHANGE_PASSWORD}}</h1>
                            <div class="standard-description"
                                 translate>{{eAuthMessages.CHANGE_PASSWORD_DESCRIPTION}}</div>
                        </ng-container> -->
                    </div>

                    <div class="p-left-15 p-right-15">
                        <div class="frankli-form-group text-left"
                             [class.frankli-form-group-invalid]="controlPassword.invalid && state.submitted"
                             [class.frankli-form-group-filled]="controlPassword.value.length > 0">
                            <label for="password"
                                   translate>{{passwordReset ? eAuthMessages.PASSWORD : eAuthMessages.NEW_PASSWORD}}</label>
                            <input type="password" id="Password" name="password" class="form-control"
                                   placeholder="Set new password" autocomplete="password"
                                   [formControl]="controlPassword" (keydown.enter)="formSubmit()">
                            <div class="frankli-form-group-alert">
                                <ng-container *ngIf="state.submitted">
                                    <div *ngIf="controlPassword.hasError('required')"
                                         translate>{{eCommonMessages.FORM_REQUIRED}}</div>
                                    <div *ngIf="controlPassword.hasError('minlength')" translate
                                         [translateParams]="{ minValue: minimumPasswordLength }">{{eCommonMessages.FORM_MIN_CHARACTER_VALUE}}</div>
                                    <div *ngIf="controlPassword.hasError('minlength')" translate
                                         [translateParams]="{ maxValue: maximumPasswordLength }">{{eCommonMessages.FORM_MAX_CHARACTER_VALUE}}</div>
                                    <div *ngIf="controlPassword.hasError('password')" translate>{{eCommonMessages.FORM_PASSWORD_SPECIAL_CHARACTERS}}</div>
                                </ng-container>
                            </div>
                        </div>

                        <div class="frankli-form-group text-left"
                             [class.frankli-form-group-invalid]="controlConfirmPassword.invalid && state.submitted"
                             [class.frankli-form-group-filled]="controlConfirmPassword.value.length > 0">
                            <label for="confirmPassword" translate>{{eAuthMessages.CONFIRM_PASSWORD}}</label>
                            <input type="password" id="confirmPassword" name="confirmPassword" class="form-control"
                                   placeholder="Confirm password" [formControl]="controlConfirmPassword"
                                   (keydown.enter)="formSubmit()">
                            <div class="frankli-form-group-alert">
                                <ng-container *ngIf="state.submitted">
                                    <div *ngIf="form.hasError('passwordmatch')"
                                         translate>{{eAuthMessages.PASSWORDS_MUST_MATCH}}</div>
                                    <div *ngIf="controlConfirmPassword.hasError('required')"
                                         translate>{{eCommonMessages.FORM_REQUIRED}}</div>
                                    <div *ngIf="controlConfirmPassword.hasError('minlength')" translate
                                         [translateParams]="{ minValue: minimumPasswordLength }">{{eCommonMessages.FORM_MIN_CHARACTER_VALUE}}</div>
                                    <div *ngIf="controlConfirmPassword.hasError('minlength')" translate
                                         [translateParams]="{ maxValue: maximumPasswordLength }">{{eCommonMessages.FORM_MAX_CHARACTER_VALUE}}</div>
                                    <div *ngIf="controlConfirmPassword.hasError('password')" translate>{{eCommonMessages.FORM_PASSWORD_SPECIAL_CHARACTERS}}</div>
                                </ng-container>
                            </div>
                        </div>
                    </div>

                    <div class="p-15 text-right">
                        <app-button [loading]="state.loading" (onClick)="formSubmit()">
                            <span translate>{{button}}</span>
                        </app-button>
                    </div>
                </div>
            </ng-container>
        </ng-container>

        <ng-template #stateLoading>
            <div class="card">
                <app-loading-state [height]="'300px'"></app-loading-state>
            </div>
        </ng-template>

        <ng-template #stateError>
            <div class="card">
                <app-error-state [height]="'300px'" [message]="state.errorMessage"></app-error-state>
            </div>
        </ng-template>
    </div>
</div>